import { render, staticRenderFns } from "./MedicalChecklist.vue?vue&type=template&id=3344fead&scoped=true"
import script from "./MedicalChecklist.vue?vue&type=script&lang=js"
export * from "./MedicalChecklist.vue?vue&type=script&lang=js"
import style0 from "./MedicalChecklist.vue?vue&type=style&index=0&id=3344fead&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3344fead",
  null
  
)

export default component.exports